import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode Renders all components twice on Development Mode so you can see the errors
  <>
    <span className='fill-fuchsia-500 stroke-fuchsia-500 border-fuchsia-500 text-fuchsia-500'> </span>
    <span className='fill-rose-700 stroke-rose-700 border-rose-700 text-rose-700 rose-700'> </span>
    <span className='fill-indigo-500 stroke-indigo-500 border-indigo-500 text-indigo-500 rose-700'> </span>

    <Router>
      <App />
    </Router>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
